export default __webpack_public_path__ + "9cd016cfa7a9a991b4ff6be3f00597c3.png";